import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
	IconButton,
	Grid,
	Dialog,
	Button,
	Typography,
	Icon,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

import CloseIcon from '@material-ui/icons/Close';
import RawMarkup from './../../../components/RawMarkup';
import moment from 'moment';

import IconC from './../../../components/_IconC';

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});

const DialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

const DialogContent = withStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},
}))(MuiDialogActions);

export default function ModalTravelInformation(props) {
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	const evalSeatReservationRepeated = (segmento) => {
		const seatReservations = [];
		for (var i = 0; i < segmento.length; i++) {
			seatReservations.push(segmento[i].seatReservationConditions);
		}
		return seatReservations.every((val, i, arr) => val === arr[0]);
	};

	switch (props.type) {
		case 'escala':
			const {
				departure,
				arrival,
				duration,
				escala,
				vehicleType,
				reference,
				date,
				destination,
				origin,
				segments,
			} = props;
			return (
				<div className="modal-escala">
					<Button
						color="primary"
						className="ver-tarifa"
						onClick={handleClickOpen}
					>
						{segments.length > 1
							? segments.length -
							  1 +
							  (segments.length - 1 === 1 ? ' escala' : ' escalas')
							: 'Directo'}
					</Button>
					<Dialog
						maxWidth="sm"
						onClose={handleClose}
						aria-labelledby="modal-travel-info"
						open={open}
					>
						<DialogTitle id="modal-travel-info" onClose={handleClose}>
							Resumen del viaje
						</DialogTitle>
						<DialogContent dividers>
							<Grid container spacing={0}>
								<Grid item xs={12}>
									<Typography className="hora" variant="h3">
										<span>{origin}</span> <Icon>arrow_forward</Icon>{' '}
										<span>{destination}</span>{' '}
										<span className="date">{departure}</span>
									</Typography>
								</Grid>
							</Grid>
							<div className="detail-tramos">
								{segments.map((data, y) => (
									<Grid container spacing={0} key={y} className="bloque-tramo">
										<Grid item xs={3}>
											<div className="origin">
												<div class="salida"></div>
												<div class="line-div"></div>
												<Typography className="hora" variant="h3">
													<span>
														{moment(data.departure)
															.locale('es')
															.format('H:mm a')}
													</span>
													<br />
													<span className="place">
														{data.origin.localLabel}
													</span>
												</Typography>
											</div>
											<div className="destination">
												<div class="llegada"></div>
												<Typography className="hora" variant="h3">
													<span>
														{moment(data.arrival).locale('es').format('H:mm a')}
													</span>
													<br />
													<span className="place">
														{data.destination.localLabel}
													</span>
												</Typography>
											</div>
										</Grid>
										<Grid item xs={9}>
											<Grid container spacing={0}>
												<Grid item xs={6}>
													<Typography className="info-tren">
														{data.vehicle.code} N°: {data.vehicle.reference}
														<br />
														{data.vehicle.type}
														<br /> {data.operatingCarrier}
													</Typography>
												</Grid>
												<Grid item xs={6}>
													<Typography variant="body2">
														<strong>Duración:</strong>
														<br />
														{data.duration}
													</Typography>
													<Typography variant="body2">
														<strong>Asiento:</strong>
														<br />
														{data.seatReservationConditions}
													</Typography>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								))}
							</div>
						</DialogContent>
						<DialogActions>
							<Button
								className="btn-outlined"
								variant="outlined"
								autoFocus
								onClick={handleClose}
								color="primary"
							>
								Cerrar
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			);
		case 'condiciones':
			const { segmento, detailConditions, ticketingOptions, ages  } = props;

			const MarketingCarrierMessage = (props) => {
				return (
					<Typography>
						<Icon className="icon">luggage</Icon>
						{props.carrier === 'ITALO' && (
							<>
								IMPORTANTE: Las tarifas Smart permiten sólo un equipaje chico
								(hasta 75x53x30cm.) por pasajero. En caso de exceso aplicará una
								multa y se solicitará el descenso en la parada siguiente. Esta
								limitación no aplica para tarifas Comfort, Prima ni Club
								Executive. Radical Storage Platform: Servicio de depósito de
								equipaje de Italo en estaciones (aprox. Є5 por día).
							</>
						)}
						{props.carrier === 'OUIGOESP' && (
							<>
								IMPORTANTE: Las tarifas Essential (Standard) permiten sólo un
								bolso de mano (hasta 27x36x15cm.) y un equipaje en cabina (hasta
								55x35x25cm.) por pasajero.
							</>
						)}
					</Typography>
				);
			};

			return (
				<div className="modal-condiciones modal-condiciones-boletos">
					<Button
						className="ver-tarifa"
						onClick={handleClickOpen}
						color="secondary"
					>
						Ver condiciones
					</Button>

					<Dialog
						maxWidth="sm"
						onClose={handleClose}
						aria-labelledby="modal-travel-info"
						open={open}
					>
						<DialogTitle id="modal-travel-info" onClose={handleClose}>
							Condiciones de la tarifa
						</DialogTitle>
						<DialogContent dividers>
							{detailConditions.map((data, y) => (
								<div key={y}>
									{/* <Typography variant="body2">{data.cabinClass.code}</Typography> */}
									<Typography variant="h2">
										{data.cabinClass ? data.cabinClass.label + '-' : ''}{' '}
										{data.label}
									</Typography>
									<Typography>
										{data.paxType
											? data.paxType.label
											: data.label
											? data.label
											: ''}
									</Typography>
									<hr />
									<Typography>
										<RawMarkup content={data.conditions} />
									</Typography>
								</div>
							))}
							<ul className="list-unstyled list-elements">
								{segmento != null && (
									<li>
										<Typography>
											<IconC
												icon="seat"
												alt="seat"
												className="custom_icon icon"
											/>
											{evalSeatReservationRepeated(segmento) ? (
												segmento[0].marketingCarrier === "DBAHN" ? (
													<span style={{ color: "red", important: true }}>
													  COSTO POR RESERVA DE ASIENTO NO INCLUIDO. EL MISMO SE
													  ADICIONARA AUTOMÁTICAMENTE AL FINALIZAR LA EMISIÓN, EN CASO DE
													  SER OBLIGATORIO (APROX. USD 6 POR PASAJERO POR TRAMO)
													</span>
												  ) : (
													<span>{segmento[0].seatReservationConditions}</span>
												  )
											) : (
												<span>
													La inclusión de asientos es variable en cada tramo.
													Haz clic en el link de las escalas para verificar
													detalle.
												</span>
											)}
										</Typography>
									</li>
								)}
								<li>
									<Typography>
										<Icon className="icon">confirmation_number</Icon>{' '}
										{ticketingOptions[0]}
									</Typography>
								</li>
								{detailConditions
									.filter(
										(segment) =>
											segment.marketingCarrier === 'ITALO' ||
											segment.marketingCarrier === 'OUIGOESP'
									)
									.map((result, i) => (
										<li key={i}>
											<MarketingCarrierMessage
												carrier={result.marketingCarrier}
											/>
										</li>
									))}
								{ props.trainService === "DBAHN" && 
                                  <li>
									<Typography>
										<Icon className="icon">
											info
										</Icon>
										<span>
											Tarifa Sparpreis: Si el ticket no es utilizado, se permite reembolso hasta 1 día antes de la fecha de salida del tren con una penalidad de Euros 10, el mismo se realizará por medio de un voucher para utilizar en futuros viajes en DB y deberá ser validado directamente en <a href="https://www.bahn.com/es/">https://www.bahn.com/es/</a>
										</span>
									</Typography>
									</li>
								}
								{(props.ages && props.page === "tickets") && 
								<li>
									<br />
									<Typography>
										<span>  
										<strong>Infoas: </strong>Viajan gratis <strong>sin derecho a asiento y sin ticket</strong> según edades: 
										Trenes Reino Unido 0-4 años, Alemania y Suiza de 0-5 años, resto de Trenes 0-3 años inclusive.
										</span>
									</Typography>
								</li>
								}
								{(props.ages && props.page === "passes") && 
								<li>
									<Typography>
										<span>  	
										<strong>Infoas: </strong>Viajan gratis <strong> sin derecho a asiento y sin ticket</strong>
										según edades: Pase Eurail 0-3 años y Pase Suizo de 0-5 años inclusive. 
										</span>
									</Typography>
								</li>
								}
							</ul>
						</DialogContent>
						<DialogActions>
							<Button
								className="btn-outlined"
								variant="outlined"
								autoFocus
								onClick={handleClose}
								color="primary"
							>
								Cerrar
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			);
		default:
			return null;
	}
}
